<template>
  <div ref="el" class="dialog-wrapper">
    <div id="dialog-effect"></div>
    <div class="dialog-wrapper-container"><slot /></div>
  </div>
</template>
<script lang="ts" setup>
const el = ref(null);
const { height, bottom, left, right, top, width, x, y } =
  useElementBounding(el);
const dialog = useDialogStore();
watchEffect(() =>
  dialog.setViewport({
    height: height.value,
    bottom: bottom.value,
    left: left.value,
    right: right.value,
    top: top.value,
    width: width.value,
    x: x.value,
    y: y.value,
  })
);
</script>
<style lang="scss" scoped>
#dialog-effect {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.dialog-wrapper {
  display: flex;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  background-color: transparent;
  &-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    @include above('l') {
      width: calc(var(--main_width));
      height: calc(100dvh - var(--header_height));
    }
  }
}
</style>
